/**
 * sg-quickview-variant-fix.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Due fix per il quickview Shopify:
 *
 * 1. APERTURA con variante corretta
 *    Quando si apre il quickview dalla product card, aggiunge &variant=ID
 *    all'URL del fetch. ButtonQuickView/ButtonSelectOptions cachano this.url
 *    nel costruttore, quindi bisogna aggiornare la proprietà JS (btn.url).
 *
 * 2. CAMBIO VARIANTE dentro il popup
 *    Il loadScripts del QuickView non esegue gli inline script correttamente.
 *    Questo file è caricato stabilmente in pagina, quindi i listener qui
 *    rimangono attivi anche quando il quickview è aperto.
 *    updateMedia() del tema cerca <media-gallery> che non esiste nel nostro
 *    layout, quindi intercettiamo il click sulla swatch e aggiorniamo
 *    direttamente l'<img class="sg-single-variant-image">.
 * ─────────────────────────────────────────────────────────────────────────────
 */
(function () {
  'use strict';

  if (window.__sgQuickviewVariantPatch) return;
  window.__sgQuickviewVariantPatch = true;

  /* ─────────────────────────────────────────────────────────────────────────
   * 1. Apertura quickview con variante selezionata sulla card
   * ───────────────────────────────────────────────────────────────────────── */

  function getSelectedVariantIdFromCard(triggerEl) {
    var card = triggerEl.closest('.product-item');
    if (!card) return null;

    var jsonScript = card.querySelector(
      'variant-radios script[type="application/json"],' +
      'variant-radios-detail script[type="application/json"]'
    );
    if (!jsonScript) return null;

    var variants;
    try { variants = JSON.parse(jsonScript.textContent); } catch (e) { return null; }
    if (!variants || !variants.length) return null;

    var activeSwatches = card.querySelectorAll(
      '.product__color-swatches--js.active,' +
      'variant-radios .active'
    );
    if (!activeSwatches.length) return null;

    var selected = {};
    activeSwatches.forEach(function (sw) {
      var pos = sw.dataset.position;
      var val = sw.dataset.value;
      if (pos && val !== undefined) selected[pos] = val.toLowerCase();
    });

    var matched = null;
    variants.forEach(function (v) {
      if (matched) return;
      var ok = true;
      Object.keys(selected).forEach(function (pos) {
        var optKey = 'option' + pos;
        if ((v[optKey] || '').toLowerCase() !== selected[pos]) ok = false;
      });
      if (ok) matched = v;
    });

    return matched ? matched.id : null;
  }

  /* Intercetta il click sul quickview PRIMA del custom element (capture=true)
     e aggiorna this.url (proprietà JS cachata al costruttore, usata da fetch) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button-quickview, select-option[data-url]');
    if (!btn) return;

    var baseUrl = btn.url || btn.getAttribute('data-url') || '';
    if (!baseUrl || baseUrl.indexOf('section_id=product-quickview') === -1) return;

    var variantId = getSelectedVariantIdFromCard(btn);
    if (!variantId) return;

    var cleanUrl = baseUrl.replace(/[&?]variant=\d+/, '');
    var sep = cleanUrl.indexOf('?') !== -1 ? '&' : '?';
    btn.url = cleanUrl + sep + 'variant=' + variantId;
  }, true /* capture */);


  /* ─────────────────────────────────────────────────────────────────────────
   * 2. Cambio variante DENTRO il popup
   * ───────────────────────────────────────────────────────────────────────── */

  function updateQuickviewImage(swatchEl) {
    /* Trova il container del quickview risalendo dal swatch */
    var container = swatchEl.closest('.product-quickview__content');
    if (!container) return;

    var picker = container.querySelector(
      'variant-radios-detail, variant-radios, variant-radios-single, variant-selects'
    );
    if (!picker || !picker.currentVariant) return;

    var cv = picker.currentVariant;
    var newSrc = null;

    if (cv.featured_media && cv.featured_media.preview_image) {
      newSrc = cv.featured_media.preview_image.src;
    } else if (cv.featured_image && cv.featured_image.src) {
      newSrc = cv.featured_image.src;
    } else if (typeof cv.featured_image === 'string') {
      newSrc = cv.featured_image;
    }

    if (!newSrc) return;

    var img = container.querySelector('.sg-single-variant-image');
    if (!img) return;

    /* Fade out → aggiorna src → fade in */
    img.style.transition = 'opacity 0.2s ease';
    img.style.opacity = '0';
    setTimeout(function () {
      img.src = newSrc;
      if (img.srcset) img.srcset = newSrc;
      img.onload = function () {
        img.style.opacity = '1';
      };
      /* Fallback nel caso onload non scatti (es. immagine in cache) */
      setTimeout(function () { img.style.opacity = '1'; }, 300);
    }, 200);
  }

  /* Intercetta il click su qualsiasi swatch dentro un quickview aperto.
     Usa bubble phase (false): il custom element ha già aggiornato currentVariant
     al momento in cui il bubble sale fino a document? No — usiamo un timeout. */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.product__color-swatches--js');
    if (!swatch) return;

    /* Verifica che sia dentro un quickview */
    if (!swatch.closest('.product-quickview__content')) return;

    /* Attende che variant-radios-detail aggiorni currentVariant */
    setTimeout(function () {
      updateQuickviewImage(swatch);
    }, 250);
  }, false);

})();
